module.exports = __webpack_public_path__ + "img/icon_heart.38b6ed89.svg";